export default __webpack_public_path__ + "static/media/background-logo.3e7574a0.png";